import React from 'react';
import H2 from '../../Components/H2';
import styled, {keyframes} from 'styled-components';
import {FormattedMessage, injectIntl} from 'react-intl';
import {Helmet} from "react-helmet";
import Success from '../../Components/Success';
import SocialButtons from '../../Components/SocialButtons';
import {zoomIn} from 'react-animations';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {BottomWrapper, CoreWrapper, TextCenter, TopWrapper} from "../../Components/Layout";
import PoweredBy from "../../Components/PoweredBy";
import {ToolbarWithLogo} from "../../Components/Toolbar";
import {humanizeDayOfWeek, serverDayDate, serverShortTime} from "../../Common/Helpers";
import ContainerPage from "../ContainerPage";
import Sizes from "../../Assets/Sizes";
import {getSafely} from "@tomeravni/easybizy-js-common/common";

const bounceAnimation = keyframes`${zoomIn}`;

const BouncyDiv = styled.div`
    position: absolute;
    bottom: 2rem;
    animation: ${bounceAnimation} .6s ease-in 0s backwards;
`;

const ContentContainer = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: ${Sizes.defaultPadding};
    padding-left: ${Sizes.defaultPadding};
    padding-right: ${Sizes.defaultPadding};
`


class WaitingListSuccessPage extends ContainerPage {
    state = {
        socialVisible: false
    };

    componentDidMount() {
        this.loadingTimer = setTimeout(() => {
            this.reloadConfigWithServices();
        }, 1000);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.config && !this.state.config) {
            this.safeSetState({socialVisible: true, config: this.props.config});
        }

        if (this.validateSuccessTimer) {
            clearTimeout(this.validateSuccessTimer);
        }

        this.validateSuccessTimer = setTimeout(() => {
            if (this.props.config && !this.props.waitingListItem) {
                this.reset();
            }
        }, 1000);


    }

    componentWillUnmount() {
        super.componentWillUnmount();
        if (this.loadingTimer) {
            clearTimeout(this.loadingTimer);
        }

        if (this.validateSuccessTimer) {
            clearTimeout(this.validateSuccessTimer);
        }
    }

    getMeetingDetails(meeting) {
        return (
            <div>{humanizeDayOfWeek(meeting.StartTime)}, {serverDayDate(meeting.StartTime)}, {serverShortTime(meeting.StartTime)} </div>);
    }

    renderMultipleMeetingRows(meetings) {
        return <div>
            <H2><FormattedMessage id="schedule.meetingsScheduled"/></H2>
            {meetings.forEach(meeting =>
                <H2>{this.getMeetingDetails(meeting)}</H2>
            )}
        </div>
    }

    render() {
        const translatedMessage = this.props.intl.formatMessage({id: 'added_to_waiting_list'});
        const {SocialLinks} = this.state.config || {};
        const ltr = !this.props.intl.locale.includes('he');
        const toolbarLogo = getSafely(['theme', 'properties', 'avatarImage'], window) || (this.props.config && this.props.config.Logo) || '';

        return (
            <div className="transition-item detail-page detail-page__success">
                <Helmet>
                    <title>{translatedMessage}</title>
                </Helmet>
                <CoreWrapper padding={true} loading={this.props.loading} invertedColors={true} ltr={ltr}>
                    <ToolbarWithLogo imageUri={toolbarLogo} invertedColors={true} hideBack={true} ltr={ltr}
                                     rootUri={this.getRoutePrefix()}/>
                    <TopWrapper>
                        <ContentContainer>
                            <TextCenter>
                                <H2 invertedColors={true}>{translatedMessage}!</H2>
                            </TextCenter>
                            <Success width={90} height={130}/>
                        </ContentContainer>
                        {this.state.socialVisible && SocialLinks && <BouncyDiv>
                            <SocialButtons
                                urls={SocialLinks}
                            />
                        </BouncyDiv>}
                    </TopWrapper>
                    <BottomWrapper empty={true}>
                        <PoweredBy/>
                    </BottomWrapper>
                </CoreWrapper>
            </div>
        );
    }
}

// export default WaitingListSuccessPage;
const mapStateToProps = state => {
    return {
        config: state.schedule.configWithServices,
        waitingListItem: getSafely(['schedule', 'configWithServices', 'WaitingListItem'], state),
    };
};

const mapDispatchToProps = dispatch => {
    return {}
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(WaitingListSuccessPage)));
